export const useModuleStore = defineStore("websiteStore", () => {
  const open = ref<Boolean>(false)
  const modules = ref({
    cms: {
      title: "İçerik Yönetim",
      description: "İçerik Yönetim Modülü",
      banner:
        "https://cdn.shopify.com/shopifycloud/shopify/assets/admin/home/onboarding/guides/pg_ImproveConversionRateGuide-6c476c248a96b277f033af4b040802f574b79d9a29c64ec5e9c82bd75abe9783.png",
      prefix: "/cms",
      icon: "tabler:contract",
      navigation: [
        {
          type: "title",
          title: "Listeler"
        },
        {
          type: "link",
          title: "Elektrikçiler",
          icon: "tabler:user-bolt",
          link: "/electrician"
        },
        {
          type: "link",
          title: "Araç Bilgileri",
          icon: "tabler:car",
          link: "/car",
          badge: "YAKINDA",
          disabled: true
        },
        {
          type: "link",
          title: "Teknik Destek",
          icon: "tabler:stethoscope",
          link: "/technical-support",
          badge: "Yeni",
          status: "success"
        },
        {
          type: "link",
          title: "Seri Numaraları",
          icon: "tabler:hash",
          link: "/serial-number"
        },
        {
          type: "link",
          title: "Çözüm Ortakları",
          icon: "tabler:heart-handshake",
          link: "/partner"
        },
        {
          type: "title",
          title: "Kargo"
        },
        {
          type: "link",
          title: "Amazon Barkod",
          icon: "tabler:barcode",
          link: "/shipping/amazon/barcode"
        },
        {
          type: "link",
          title: "İkas Kargo Listesi",
          icon: "tabler:bolt",
          link: "/shipping/ikas"
        },
        {
          type: "title",
          title: "Yanıtlar (Google Sheets)"
        },
        {
          type: "link",
          title: "İade",
          icon: "tabler:table",
          link: "/sheets/refund"
        },
        {
          type: "link",
          title: "Teknik Destek",
          icon: "tabler:table",
          link: "/sheets/support"
        }
      ]
    },
    currency: {
      title: "Canlı Döviz Takibi",
      description: "Canlı Döviz Takibi Modülü",
      prefix: "/currency",
      icon: "tabler:coin"
    },
    test: {
      title: "Test Alanı",
      description: "Test Yönetim Modülü",
      prefix: "/test",
      icon: "tabler:test-pipe",
      navigation: []
    }
  })

  return {
    open,
    modules
  }
})
